export function EmptyChatPlaceholder() {
  return (
    /* Empty state */
    <div className="flex flex-1 flex-col items-center justify-center px-8 text-center gap-4">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className="text-brand-primary"
      >
        <path
          d="M8.84099 2.75C8.7425 2.75 8.64497 2.7694 8.55398 2.80709C8.46298 2.84478 8.3803 2.90003 8.31066 2.96967C8.24101 3.03931 8.18577 3.12199 8.14808 3.21299C8.11039 3.30398 8.09099 3.40151 8.09099 3.5C8.09099 3.59849 8.11039 3.69602 8.14808 3.78701C8.18577 3.87801 8.24101 3.96069 8.31066 4.03033C8.3803 4.09997 8.46298 4.15522 8.55398 4.19291C8.64497 4.2306 8.7425 4.25 8.84099 4.25H9.14399V11.207L5.68399 14.957L5.63099 15.02C5.55232 15.1253 5.46299 15.2433 5.36299 15.374C4.93299 15.933 4.34999 16.693 4.02799 17.453C3.82099 17.941 3.68099 18.513 3.78599 19.106C3.89599 19.724 4.25299 20.262 4.84499 20.693C5.30099 21.026 5.87899 21.141 6.50299 21.195C7.12999 21.25 7.94299 21.25 8.95799 21.25H15.042C16.058 21.25 16.87 21.25 17.497 21.195C18.121 21.141 18.699 21.025 19.155 20.693C19.747 20.262 20.105 19.723 20.215 19.106C20.32 18.512 20.179 17.941 19.972 17.453C19.65 16.693 19.067 15.933 18.637 15.373C18.537 15.2437 18.4477 15.126 18.369 15.02L18.316 14.956L14.856 11.206V4.25H15.159C15.3579 4.25 15.5487 4.17098 15.6893 4.03033C15.83 3.88968 15.909 3.69891 15.909 3.5C15.909 3.30109 15.83 3.11032 15.6893 2.96967C15.5487 2.82902 15.3579 2.75 15.159 2.75H8.84099Z"
          fill="currentColor"
        />
      </svg>
      <p className="text-sm text-brand-muted">
        Start a conversation or upload a scenario to test how the application
        operates.
      </p>
    </div>
  );
}
